// Mixins
import { tableMixins } from '@/app/mixins/utils/table-mixins.js';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins.js'
import { inputTextMixins } from '@/app/mixins/utils/input-text-mixins';

// Constants
import { STATUS_CODES } from '@/app/constants/constants';

// Service
import SocialClubService from '@/app/services/main/social-club/social-club-service.js';

export default {
	name: 'SocialClubUsersContainer',
	mixins: [ tableMixins, toastMessageMixins, inputTextMixins ],
	data() {
		return {
			isAPILoading: false,
			// table
			theads: [
				{ name: 'Member', searchLabel: 'f_name', sortLabel: 'name', placeHolder:'Customer Name' ,isDesc: false, hasSearch: true, style: null },
				{ name: 'Member Access', searchLabel: 'f_access', sortLabel: 'access', isDesc: false, hasSearchDown: true, style: null }
			],
			// sorting
			desc: true,
			// filter
			filterMember: '',
			adminStatusList: [
				{ name:'Member', value: 'CM' },
				{ name:'Admin', value: 'CA' },
				{ name:'Creator', value: 'CC' },
				{ name: 'Pending request', value: 'PR'}
			],
			accessDisplay: {
				CM: 'Member',
				CA: 'Admin',
				CC: 'Creator',
				PR: 'Pending Admin Request'
			},
			selectedAdminStatus: '',
			selectedGroup: '',
			// breeds
			isBreedsListLoading: false,
			groupList: []
		}
	},
	computed: {
		getGroup() {
			return this.$store.getters.getActiveGroup;
		}
	},
	watch: {
		filterMember() {
			this.delayTyping(() => {
				this.getTableContent(true);
			});	
		},
		selectedAdminStatus() {
			this.getTableContent(true);
		},
		getGroup(val) {
			if (val) {
				this.getTableContent();
			}
		}
	},
	mounted() {
		if (this.getGroup.id === 1001) {
			this.theads = [
				{ name: 'Member', searchLabel: 'f_name', sortLabel: 'name', placeHolder:'Customer Name' ,isDesc: false, hasSearch: true, style: null }
			]
		}
		
		this.getTableContent();
	},
	methods: {
		backToGroup() {
			this.$router.push('/social');
		},
		getTableContent(fromFilter = false, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
			page = fromFilter ? 1 : this.page;
			this.getMemberClubList({ page, limit, sortBy, desc });
		},
		getMemberClubList(queryParams) {
		
			// Append default filter
			queryParams['f_groupId'] = this.getGroup.id;
			queryParams['f_status'] = 'ACTIVE';
			
			// Append reporter filter
			if (this.filterMember) {
				queryParams['f_name'] = this.filterMember;
			}

			// Append status filter
			if (this.selectedAdminStatus) {
				queryParams['f_access'] = this.selectedAdminStatus;
			}

			this.isAPILoading = false;

			SocialClubService.getGroupMembers(queryParams)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.tableContent = {
							tableData: res.data.data,
							paginationData: res.data.pagination
						};
						this.isAPILoading = false;
					} else {
						this.showAPIErrorToast('Unable to fetch social club members list.', res);
						this.isAPILoading = false;
					}
				});
		},
	}
}